/* eslint-disable max-len */
import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import DownloadWithQuery from './DownloadWithQuery';

const schema: JSONSchema7 = {
    title: 'Download With Graphql Query',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        dataSourceType: {
            type: 'string',
            title: 'Data Source Type',
            enum: ['', 'GraphQL'],
            default: 'GraphQL',
        },
        dataSource: {
            type: 'string',
            title: 'Data Source',
            default: '',
        },
        query: {
            type: 'string',
            title: 'Graphql query',
            description: 'A graphql query',
            default: '',
        },
        queryVariables: {
            type: 'string',
            title: 'Query variables',
            description: 'Query variables',
            default: '',
        },
        transform: {
            type: 'string',
            title: 'Query Transform',
            default: '',
        },
        transformFunction: {
            type: 'string',
            title: 'Transform function',
            description: 'A transform function to transform the data for download',
            default:
                'return (_data) => {\r\n      const {data} = _data;\r\n     return {...data};\r\n};',
        },
        fileName: {
            type: 'string',
            title: 'Download File Name',
            default: '',
        },
        buttonLabel: {
            type: 'string',
            title: 'Download Button Label',
            default: 'Download',
        },
        showButtonIcon: {
            type: 'boolean',
            title: 'Show Button Icon',
            default: false,
            enum: [true, false],
        },
        showLoadingIcon: {
            type: 'boolean',
            title: 'Show Loading Icon',
            default: false,
            enum: [true, false],
        },
        showErrorMessage: {
            type: 'boolean',
            title: 'Show Error Message',
            default: false,
            enum: [true, false],
        },
        addColumns: {
            type: 'boolean',
            title: 'Add Columns',
            default: false,
            enum: [true, false],
        },
    },
    dependencies: {
        showButtonIcon: {
            oneOf: [
                {
                    properties: {
                        showButtonIcon: {
                            enum: [true],
                        },
                        buttonIconPosition: {
                            type: 'string',
                            title: 'Button Icon position',
                            enum: ['Right', 'Left'],
                            default: 'Right',
                        },
                        buttonIconType: {
                            type: 'string',
                            title: ' Button Icon type',
                            enum: ['FontAwesome Icon', 'Image'],
                            default: 'FontAwesome Icon',
                        },
                    },
                    dependencies: {
                        buttonIconType: {
                            oneOf: [
                                {
                                    properties: {
                                        buttonIconType: {
                                            enum: [`FontAwesome Icon`],
                                        },
                                        buttonIconName: {
                                            type: 'string',
                                            title: 'Button Icon name',
                                            default: 'fa-solid fa-download',
                                        },
                                    },
                                },
                                {
                                    properties: {
                                        buttonIconType: {
                                            enum: ['Image'],
                                        },
                                        buttonIconImageUrl: {
                                            type: 'string',
                                            title: 'Button Show Image url',
                                        },
                                        butttonImgAltText: {
                                            type: 'string',
                                            title: 'Button Image Alt Text',
                                            default: 'button-icon',
                                        },
                                    },
                                },
                            ],
                        },
                    },
                },
                {
                    properties: {
                        showButtonIcon: { enum: [false] },
                    },
                },
            ],
        },
        showLoadingIcon: {
            oneOf: [
                {
                    properties: {
                        showLoadingIcon: {
                            enum: [true],
                        },
                        loadingIconPosition: {
                            type: 'string',
                            title: 'Loading Icon position',
                            enum: ['Right', 'Left'],
                            default: 'Right',
                        },
                        loadingIconType: {
                            type: 'string',
                            title: ' Loading Icon type',
                            enum: ['FontAwesome Icon', 'Image'],
                            default: 'FontAwesome Icon',
                        },
                    },
                    dependencies: {
                        loadingIconType: {
                            oneOf: [
                                {
                                    properties: {
                                        loadingIconType: {
                                            enum: ['FontAwesome Icon'],
                                        },
                                        loadingIconName: {
                                            type: 'string',
                                            title: 'Loading Icon name',
                                            default: 'fa-circle-notch fa-spin fa-xs',
                                        },
                                    },
                                },
                                {
                                    properties: {
                                        loadingIconType: {
                                            enum: ['Image'],
                                        },
                                        loadingIconImageUrl: {
                                            type: 'string',
                                            title: 'Loading Show Image url',
                                        },
                                        loadingImgAltText: {
                                            type: 'string',
                                            title: 'Loading Image Alt Text',
                                            default: 'loading-icon',
                                        },
                                    },
                                },
                            ],
                        },
                    },
                },
                {
                    properties: {
                        showLoadingIcon: { enum: [false] },
                    },
                },
            ],
        },
        showErrorMessage: {
            oneOf: [
                {
                    properties: {
                        showErrorMessage: {
                            enum: [true],
                        },
                        showErrorIcon: {
                            type: 'boolean',
                            title: 'Show Error Icon',
                            default: false,
                            enum: [true, false],
                        },
                    },
                    dependencies: {
                        showErrorIcon: {
                            oneOf: [
                                {
                                    properties: {
                                        showErrorIcon: {
                                            enum: [true],
                                        },
                                        errorIconPosition: {
                                            type: 'string',
                                            title: 'Error Icon position',
                                            enum: ['Right', 'Left'],
                                            default: 'Right',
                                        },
                                        errorIconType: {
                                            type: 'string',
                                            title: ' Error Icon type',
                                            enum: ['FontAwesome Icon', 'Image'],
                                            default: 'FontAwesome Icon',
                                        },
                                    },
                                    dependencies: {
                                        errorIconType: {
                                            oneOf: [
                                                {
                                                    properties: {
                                                        errorIconType: {
                                                            enum: ['FontAwesome Icon'],
                                                        },
                                                        errorIconName: {
                                                            type: 'string',
                                                            title: 'Error Icon name',
                                                            default: 'fa-exclamation-circle',
                                                        },
                                                    },
                                                },
                                                {
                                                    properties: {
                                                        errorIconType: {
                                                            enum: ['Image'],
                                                        },
                                                        errorIconImageUrl: {
                                                            type: 'string',
                                                            title: 'Error Show Image url',
                                                        },
                                                        errorImgAltText: {
                                                            type: 'string',
                                                            title: 'Error Image Alt Text',
                                                            default: 'error-icon',
                                                        },
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                },
                                {
                                    properties: {
                                        showErrorIcon: { enum: [false] },
                                    },
                                },
                            ],
                        },
                    },
                },
                {
                    properties: {
                        showErrorMessage: { enum: [false] },
                    },
                },
            ],
        },
        addColumns: {
            oneOf: [
                {
                    properties: {
                        addColumns: {
                            enum: [true],
                        },
                        columns: {
                            type: 'array',
                            title: 'Columns',
                            items: {
                                type: 'object',
                                properties: {
                                    label: {
                                        type: 'string',
                                        title: 'Column label',
                                    },
                                    value: {
                                        type: 'string',
                                        title: 'Column Value',
                                    },
                                },
                            },
                        },
                    },
                },
                {
                    properties: {
                        addColumns: { enum: [false] },
                    },
                },
            ],
        },
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        'Query Options': [
            'dataSourceType',
            'dataSource',
            'query',
            'queryVariables',
            'transform',
            'transformFunction',
        ],
        'Download Options': [
            'fileName',
            'buttonLabel',
            'showButtonIcon',
            'buttonIconPosition',
            'buttonIconType',
            'buttonIconName',
            'buttonIconImageUrl',
            'butttonImgAltText',
            'showLoadingIcon',
            'loadingIconPosition',
            'loadingIconType',
            'loadingIconName',
            'loadingIconImageUrl',
            'loadingImgAltText',
            'showErrorMessage',
            'showErrorIcon',
            'errorIconPosition',
            'errorIconType',
            'errorIconName',
            'errorIconImageUrl',
            'errorImgAltText',
            'addColumns',
            'columns',
        ],
    },
];

const uiSchema = {
    'ui:groups': groups,
    ...customSchemas.textSchema.TextSchema.uiSchema,
    ...customSchemas.styleSchema.StyleSchema.uiSchema,
    ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
    styles: {
        'ui:widget': 'CSSEditor',
    },
    dataSourceType: { 'ui:widget': 'CustomSelect' },
    dataSource: { 'ui:widget': 'CustomTextInput' },
    query: { 'ui:widget': 'JSEditor' },
    queryVariables: { 'ui:widget': 'JSEditor' },
    transform: { 'ui:widget': 'JSEditor' },
    transformFunction: { 'ui:widget': 'JSEditor' },
    fileName: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    buttonLabel: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    showButtonIcon: { 'ui:widget': 'CustomCheckbox' },
    buttonIconPosition: { 'ui:widget': 'CustomSelect' },
    buttonIconType: { 'ui:widget': 'CustomSelect' },
    buttonIconName: { 'ui:widget': 'CustomTextInput' },
    buttonIconImageUrl: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
    butttonImgAltText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    showLoadingIcon: { 'ui:widget': 'CustomCheckbox' },
    loadingIconPosition: { 'ui:widget': 'CustomSelect' },
    loadingIconType: { 'ui:widget': 'CustomSelect' },
    loadingIconName: { 'ui:widget': 'CustomTextInput' },
    loadingIconImageUrl: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
    loadingImgAltText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    showErrorMessage: { 'ui:widget': 'CustomCheckbox' },
    showErrorIcon: { 'ui:widget': 'CustomCheckbox' },
    errorIconPosition: { 'ui:widget': 'CustomSelect' },
    errorIconType: { 'ui:widget': 'CustomSelect' },
    errorIconName: { 'ui:widget': 'CustomTextInput' },
    errorIconImageUrl: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
    errorImgAltText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
    addColumns: { 'ui:widget': 'CustomCheckbox' },
    columns: {
        items: {
            label: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
            value: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
        },
    },
};

const DownloadWithQueryWidget: commonTypes.IWidget = {
    schema,
    uiSchema,
    templateView: DownloadWithQuery,
    id: 'DownloadWithQuery',
    group: 'data',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default DownloadWithQueryWidget;
